import { __awaiter } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import { dispatch } from '@@/store';
import { showInfo } from '@/components';
import Api from '@/services';
import { judgeObj, judgeArr, dealValueShow, availableMoney, thousandBitSeparator } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
import Authorized from '@/components/Auth/auth';
/**
 *  @desc 接口公共数据
 */
const _common1 = (data) => {
    return {
        total: dealValueShow(thousandBitSeparator(data.totalBondY)),
        available: dealValueShow(thousandBitSeparator(data.totalAvailableY)),
        frozen: dealValueShow(thousandBitSeparator(data.totalFrozenY)),
    };
};
const _common2 = (data) => {
    const { i, pageIndex, v } = data;
    return {
        key: i,
        number: pageIndex * 20 - 19 + i,
        id: dealValueShow(v.userid),
        accountId: dealValueShow(v.id),
        name: dealValueShow(v.username),
        mobile: dealValueShow(v.mobile),
        numberPlate: dealValueShow(v.numberPlate),
        authenticated: v.authenticated,
        availableMargin: availableMoney(v.balanceY),
        frozenMargin: dealValueShow(thousandBitSeparator(v.frozenY)),
        totalMargin: dealValueShow(thousandBitSeparator(v.totalY)),
        balanceY: v.balanceY,
        tanantCode: v.tanantCode,
    };
};
const initState = {
    columns: [
        {
            title: '序号',
            dataIndex: 'number',
            width: 100,
        }, {
            title: '经销商ID',
            dataIndex: 'id',
            width: 200,
        }, {
            title: '经销商名称',
            dataIndex: 'name',
            render: (text, record, index) => {
                return (<a href="javascript:;" onClick={() => showInfo(record.type, record.id)}>
            {record.name}
          </a>);
            },
            width: 200,
        }, {
            title: '可用保证金(元)',
            dataIndex: 'availableMargin',
            width: 200,
        }, {
            title: '冻结保证金(元)',
            dataIndex: 'frozenMargin',
            width: 200,
        }, {
            title: '保证金总额(元)',
            dataIndex: 'totalMargin',
            width: 200,
        }, {
            title: '操作',
            dataIndex: 'option',
            render: (text, record, index) => {
                const { type } = record;
                let chargePayAllow = '';
                let refundPayAllow = '';
                let lubanIDLook = '';
                switch (type) {
                    case 'buyer':
                        chargePayAllow = 'psgjb-finanbuydepo-recharge';
                        refundPayAllow = 'psgjb-finanbuydepo-drawback';
                        lubanIDLook = 'PSGJB-FIANCE-MJBZJ-CK';
                        break;
                    case 'seller':
                        chargePayAllow = 'psgjb-finansedepo-recharge';
                        refundPayAllow = 'psgjb-finansedepo-drawback';
                        lubanIDLook = 'PSGJB-FIANCE-MJABZJ-CK';
                        break;
                }
                return (<div className={'table-operate-btn'}>
            <a luban-id={lubanIDLook} href="javascript:;" onClick={() => {
                    dispatch.moneyManage.toDetail(record);
                }}>
              查看
            </a>
            <Authorized allow={chargePayAllow}>
              <a href="javascript:;" onClick={() => {
                    dispatch.moneyManage.chargePay(record);
                }}>
                充值
              </a>
            </Authorized>
            {Number(record.balanceY || 0) > 0 &&
                    <Authorized allow={refundPayAllow}>
                <a href="javascript:;" onClick={() => {
                        dispatch.moneyManage.refundPay(record);
                    }}>
                  退款
                </a>
              </Authorized>}

          </div>);
            },
            width: 250,
        }
    ],
    columnsBuyer: [
        {
            title: '序号',
            dataIndex: 'number',
            width: 100,
        },
        {
            title: '经销商ID',
            dataIndex: 'id',
            width: 200,
        },
        {
            title: '经销商名称',
            dataIndex: 'name',
            render: (text, record, index) => {
                return (<a href="javascript:;" onClick={() => showInfo(record.type, record.id)}>
            {record.name}
          </a>);
            },
            width: 200,
        },
        {
            title: '手机号',
            dataIndex: 'mobile',
            width: 200,
        },
        {
            title: '号牌',
            dataIndex: 'numberPlate',
            width: 200,
        },
        {
            title: '可用保证金(元)',
            dataIndex: 'availableMargin',
            width: 200,
        },
        {
            title: '冻结保证金(元)',
            dataIndex: 'frozenMargin',
            width: 200,
        },
        {
            title: '保证金总额(元)',
            dataIndex: 'totalMargin',
            width: 200,
        },
        {
            title: '操作',
            dataIndex: 'option',
            render: (text, record, index) => {
                const { type } = record;
                let chargePayAllow = '';
                let refundPayAllow = '';
                let lubanIDLook = '';
                switch (type) {
                    case 'buyer':
                        chargePayAllow = 'psgjb-finanbuydepo-recharge';
                        refundPayAllow = 'psgjb-finanbuydepo-drawback';
                        lubanIDLook = 'PSGJB-FIANCE-MJBZJ-CK';
                        break;
                    case 'seller':
                        chargePayAllow = 'psgjb-finansedepo-recharge';
                        refundPayAllow = 'psgjb-finansedepo-drawback';
                        lubanIDLook = 'PSGJB-FIANCE-MJABZJ-CK';
                        break;
                }
                return (<div className={'table-operate-btn'}>
            <a luban-id={lubanIDLook} href="javascript:;" onClick={() => {
                    dispatch.moneyManage.toDetail(record);
                }}>
              查看
            </a>
            <Authorized allow={chargePayAllow}>
              <a href="javascript:;" onClick={() => {
                    dispatch.moneyManage.chargePay(record);
                }}>
                充值
              </a>
            </Authorized>
            {Number(record.balanceY || 0) > 0 &&
                    <Authorized allow={refundPayAllow}>
                <a href="javascript:;" onClick={() => {
                        dispatch.moneyManage.refundPay(record);
                    }}>
                  退款
                </a>
              </Authorized>}
            {record.numberPlate === fontEndConfig.noValueReplace && <Authorized allow={'psgjb-dealerbuyer-operate'}>
                <a href="javascript:;" onClick={() => {
                    if (record.authenticated === 1) {
                        dispatch.buyer.SHOW_CODE_EDIT(Object.assign(Object.assign({}, record), { userId: record.id }));
                    }
                    else {
                        notification.warn({
                            message: '该买家未完成实名认证，不可添加号牌',
                        });
                    }
                }}>
                  添加号牌
                </a>
              </Authorized>}
          </div>);
            },
            width: 250,
        }
    ],
    data: [],
    totalNum: 0,
    totalMoney: 0,
    availableMoney: 0,
    frozenMoney: 0,
    showPayConfirm: false,
    modalType: 'charge',
    isSeller: false,
    pageSize: 20,
    pageIndex: 1,
    searchData: {},
    choosedOrderId: '',
    choosedHandPrice: 0,
    tableLoading: false,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * @desc 加载 买家端|卖家端 可用保证金|冻结保证金|保证金总额
         */
        loadMoney(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { isSeller, searchData } = state;
                console.log('isSeller', isSeller);
                const { userName, mobile, souCheCode } = searchData;
                let money;
                if (isSeller) {
                    money = yield this.sellerAllMoney({ souCheCode });
                }
                else {
                    money = yield this.buyerAllMoney({
                        userName,
                        mobile,
                    });
                }
                this.SET_STATE({
                    totalMoney: money.total,
                    availableMoney: money.available,
                    frozenMoney: money.frozen,
                });
            });
        },
        /**
         * @desc 加载 买家端|卖家端 列表数据
         */
        loadList(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { isSeller, pageIndex, pageSize, searchData } = state;
                const { userName, mobile, souCheCode } = searchData;
                const _paramDefault = {
                    currentIndex: pageIndex,
                    pageSize,
                };
                const _sellerParam = Object.assign(Object.assign({}, _paramDefault), { souCheCode });
                const _buyerParam = Object.assign(Object.assign({}, _paramDefault), { distributor: userName, mobile });
                // console.log('加载 买家端|卖家端 列表数据 _param', _param);
                this.SET_STATE({ tableLoading: true });
                let _r;
                if (isSeller) {
                    _r = yield this.sellerList(_sellerParam);
                }
                else {
                    _r = yield this.buyerList(_buyerParam);
                }
                this.SET_STATE({ tableLoading: false });
                this.SET_STATE({
                    data: _r.items,
                    totalNum: _r.totalNum,
                });
            });
        },
        /**
         * @desc 全部卖家保证金总额
         */
        sellerAllMoney(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = { total: 0, available: 0, frozen: 0 };
                return Api.finance.allSellerMoney(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result = _common1(data);
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 卖家保证金列表
         */
        sellerList(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageIndex } = rootState.moneyManage;
                payload.buyerTag = 2; // 卖家标识
                return Api.finance.sellerDepositList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign(Object.assign({}, _common2({ i, v, pageIndex })), { type: 'seller' });
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 全部买家保证金总额
         */
        buyerAllMoney(payload) {
            return __awaiter(this, void 0, void 0, function* () {
                let result = { total: 0, available: 0, frozen: 0 };
                return Api.finance.allBuyerMoney(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    result = _common1(data);
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 买家保证金列表
         */
        buyerList(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                const { pageIndex } = rootState.moneyManage;
                payload.buyerTag = 1; // 买家标识
                return Api.finance.buyerDepositList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign(Object.assign({}, _common2({ i, v, pageIndex })), { type: 'buyer' });
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 跳转详情
         */
        toDetail(payload, { update, state, rootState }) {
            const { id, tanantCode, name } = payload;
            const { isSeller } = rootState.moneyManage;
            const path = `/finance/moneyManage/${isSeller ? 'sellermargin' : 'buyermargin'}/detail`;
            const query = { id, isSeller: String(isSeller), tanantCode, name };
            dispatch.router.push({ path, query });
        },
        /**
         * @desc 充值
         */
        chargePay(payload, { update, state, rootState }) {
            const { id } = payload;
            if (id) {
                this.SET_MODAL_TYPE('charge');
                this.SET_CHOOSE_ORDERID(id);
                dispatch.payMoneyModal.getPayRadios({ type: 'charge' });
                this.SHOW_PAYCONFIRM();
            }
        },
        /**
         * @desc 退款
         */
        refundPay(payload, { update, state, rootState }) {
            const { id, balanceY } = payload;
            if (id && balanceY) {
                this.SET_MODAL_TYPE('refund');
                this.SET_CHOOSE_ORDERID(id);
                this.SET_CHOOSE_HANDPRICE(balanceY);
                dispatch.payMoneyModal.getPayRadios({ type: 'refund' });
                this.SHOW_PAYCONFIRM();
            }
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        RESET_STATE2(state) {
            return Object.assign(Object.assign({}, initState), { isSeller: state.isSeller });
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_PAYCONFIRM(state) {
            state.showPayConfirm = true;
        },
        HIDE_PAYCONFIRM(state) {
            state.showPayConfirm = false;
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
        SET_SEARCHDATA(state, payload) {
            state.searchData = payload;
        },
        SET_CHOOSE_HANDPRICE(state, payload) {
            state.choosedHandPrice = payload;
        },
        SET_CHOOSE_ORDERID(state, payload) {
            state.choosedOrderId = payload;
        },
        SET_MODAL_TYPE(state, payload) {
            state.modalType = payload;
        },
    },
});
